import { DownloadLinkEnh } from "../../../../../components/common/DownloadLink/DownloadLinkEnh";

export default function CatatanDosenCol({ catatanDosen }) {
  return (
    <div className=" p-2 flex flex-col gap-2">
      <div className="flex flex-row items-stretch rounded-md border border-slate-300">
        <div className="flex-none flex items-center align-center w-20 py-1 px-2 font-bold bg-slate-300">
          Catatan
        </div>
        <div className="py-1 px-2 whitespace-pre-wrap">
          {catatanDosen.catatan_revisi ? catatanDosen.catatan_revisi : "-"}
        </div>
      </div>
      {catatanDosen.nama_berkas_revisi && (
        <div className="flex flex-row items-stretch rounded-md border border-slate-300">
          <div className="flex-none w-20 py-1 px-2 font-bold bg-slate-300">
            Berkas
          </div>
          <div className="py-1 px-2">
            <DownloadLinkEnh
              endpoint={`/file/berkas/get/${catatanDosen.nama_berkas_revisi}/`}
              label="Unduh"
            />
          </div>
        </div>
      )}
    </div>
  );
}
